<template>
	<div>
		<AppHeader title="계약 내역" is-history />

		<AppContent>
			<ContractList />
		</AppContent>

		<AppFooter />
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppFooter from '@/components/common/AppFooter';
import AppContent from '@/components/common/AppContent';
import ContractList from '@/components/Contract/ContractList';

export default {
	components: {
		AppHeader,
		AppFooter,
		AppContent,
		ContractList,
	},
};
</script>
